import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'authenticationSlice',
    initialState: {
        // loginData: '',
        token: localStorage.getItem('token'),
        menu: localStorage.getItem('menu'),
        isNewUser: localStorage.getItem('isNewUser'),
        userId: localStorage.getItem('userId'),
        expiryTime: localStorage.getItem('expiryTime'),
        loginAttempts: localStorage.getItem('loginAttempts'),
        fullUserDetails: localStorage.getItem('fullUserDetails'),
        userDetails: localStorage.getItem('userDetails')
        // isNewUser: '',
        // userId: ''
        // loggedIn: localStorage.getItem("loggedIn"),
    },
    reducers: {
        LOGIN_SUCCESS: (state, action) => {
            return {
                ...state,
                // loginData: action.payload,
                // token: localStorage.getItem('token'),
                menu: localStorage.getItem('menu'),
                isNewUser: localStorage.getItem('isNewUser'),
                userId: localStorage.getItem('userId'),
                expiryTime: localStorage.getItem('expiryTime'),
                loginAttempts: localStorage.getItem('loginAttempts'),
                fullUserDetails: localStorage.getItem('fullUserDetails'),
                userDetails: localStorage.getItem('userDetails')
                // isNewUser: localStorage.setItem('isNewUser', action?.payload?.tblAppUser?.passwordUpdateFlag),
                // userId: localStorage.setItem('userId', action?.payload?.tblUser?.userId)
                // loggedIn: localStorage.getItem("loggedIn"),
            };
        },
        LOGIN_ERROR: (state) => {
            return {
                ...state,
                menu: '',
                token: '',
                isNewUser: '',
                userId: '',
                expiryTime: '',
                loginAttempts: '',
                fullUserDetails: '',
                userDetails: ''
                // password: '',
                // email: ''
            };
        }
    }
});

export const { LOGIN_SUCCESS, LOGIN_ERROR } = slice.actions;
export default slice.reducer;
